'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _QuickReply = require('ui-addon-conversations/components/QuickReply');

var _QuickReply2 = _interopRequireDefault(_QuickReply);

var _UICheckbox = require('UIComponents/input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var QuickReplyGroup = _react2.default.createClass({
  displayName: 'QuickReplyGroup',

  propTypes: {
    options: _react.PropTypes.instanceOf(_immutable.Set).isRequired,
    multiSelect: _react.PropTypes.bool.isRequired,
    hasSentReply: _react.PropTypes.bool.isRequired,
    onSendMulti: _react.PropTypes.func,
    onSendIndividual: _react.PropTypes.func,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      multiSelect: false,
      hasSentReply: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      selected: (0, _immutable.Set)()
    };
  },
  hasSelected: function hasSelected() {
    var selected = this.state.selected;


    return selected.size > 0;
  },
  handleSelect: function handleSelect(option) {
    this.setState(function (_ref) {
      var selected = _ref.selected;

      var updatedSelected = selected.includes(option) ? selected.delete(option) : selected.add(option);

      return { selected: updatedSelected };
    });
  },
  handleSendMulti: function handleSendMulti() {
    var _props = this.props,
        multiSelect = _props.multiSelect,
        onSendMulti = _props.onSendMulti;
    var selected = this.state.selected;


    var canSendMultiple = multiSelect && onSendMulti && this.hasSelected();

    if (canSendMultiple) {
      onSendMulti(selected.toJS());
    }
  },
  handleSendIndividual: function handleSendIndividual(option) {
    var _props2 = this.props,
        multiSelect = _props2.multiSelect,
        onSendIndividual = _props2.onSendIndividual;


    var canSendIndividual = !multiSelect && onSendIndividual;

    if (canSendIndividual) {
      onSendIndividual(option);
    }
  },
  renderOptions: function renderOptions() {
    var _props3 = this.props,
        options = _props3.options,
        multiSelect = _props3.multiSelect,
        coloring = _props3.coloring;
    var selected = this.state.selected;


    var onClick = multiSelect ? this.handleSelect : this.handleSendIndividual;

    return options.map(function (option) {
      var boundOnClick = function boundOnClick() {
        return onClick(option);
      };
      var checked = selected.includes(option);

      var checkbox = multiSelect && _react2.default.createElement(_UICheckbox2.default, {
        className: 'm-right-2',
        style: { minHeight: 10 },
        size: 'small',
        color: coloring.accentColor,
        checked: checked,
        onChange: boundOnClick
      });

      return _react2.default.createElement(
        _QuickReply2.default,
        {
          key: 'quickreply.' + option,
          onClick: boundOnClick,
          coloring: coloring
        },
        checkbox,
        option
      );
    });
  },
  renderSendButton: function renderSendButton() {
    var _props4 = this.props,
        multiSelect = _props4.multiSelect,
        coloring = _props4.coloring;


    if (!multiSelect) {
      return null;
    }

    var disabled = !this.hasSelected();

    return _react2.default.createElement(
      _QuickReply2.default,
      {
        key: 'send-button',
        use: 'primary',
        coloring: coloring,
        disabled: disabled,
        onClick: this.handleSendMulti
      },
      _react2.default.createElement(_UIIcon2.default, { name: 'check' })
    );
  },
  render: function render() {
    var hasSentReply = this.props.hasSentReply;


    if (hasSentReply) {
      return null;
    }

    var content = [].concat(_toConsumableArray(this.renderOptions()), [this.renderSendButton()]);

    return _react2.default.createElement(
      'div',
      { className: 'align-center flex-wrap m-y-2' },
      content
    );
  }
});

exports.default = QuickReplyGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/QuickReplyGroup.js
// module id = 403
// module chunks = 0 1